export class ServiceEntity {

    totalUnits: number;
    totalUsed: number;
    totalLeft: number;
    useOrLoseBy: string;
    contractType: string;
    serviceType: string;
    contractStart: string;
    unitDuration: number;

    constructor ( 
        totalUnits: number, 
        totalUsed: number, 
        totalLeft: number, 
        useOrLoseBy: string, 
        contractType: string, 
        serviceType: string, 
        contractStart: string,
        unitDuration: number
    ) {
        this.unitDuration = unitDuration;
        let unitToMinutes = 60;
        if(unitDuration == 1) unitToMinutes = 1;
        else if(unitDuration == 2) unitToMinutes = 15;
        else if(unitDuration == 3) unitToMinutes = 30;

        this.totalUnits = totalUnits * unitToMinutes;
        this.totalUsed = totalUsed * unitToMinutes;
        this.totalLeft = totalLeft * unitToMinutes; 
        this.useOrLoseBy = useOrLoseBy;
        this.contractType = contractType == '0' ? '' : contractType;
        this.serviceType = serviceType;
        this.contractStart = contractStart;
    }
}
